export default __webpack_public_path__ + "static/CopernicusWeb-Book-0d558dcdc557206a8620ee9eaf1b6528.woff2";